export default __webpack_public_path__ + "static/media/ryzen3800x.099cc69a.jpg";